export default __webpack_public_path__ + "static/media/logo-white.97a756c2.png";